import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Form } from 'antd';
import Translate from 'react-translate-component';

import { formItemLayout } from 'constants/formItemLayout';

export default class AllDayField extends Component {
    static propTypes = {
        label: PropTypes.element,
        labelCol: PropTypes.object,
        wrapperCol: PropTypes.object,
        checked: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        labelCol: formItemLayout.labelCol,
        wrapperCol: formItemLayout.wrapperCol
    };

    render() {
        const { labelCol, wrapperCol, checked, onChange } = this.props;

        return (
            <Form.Item
                label={<Translate content="events.allday" />}
                labelCol={labelCol}
                wrapperCol={wrapperCol}
            >
                <Switch checked={checked} onChange={onChange} />
            </Form.Item>
        );
    }
}
